import { render, staticRenderFns } from "./GalleryImageZoom.vue?vue&type=template&id=0d4c18fa&scoped=true&"
import script from "./GalleryImageZoom.vue?vue&type=script&lang=js&"
export * from "./GalleryImageZoom.vue?vue&type=script&lang=js&"
import style0 from "./GalleryImageZoom.vue?vue&type=style&index=0&id=0d4c18fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c18fa",
  null
  
)

export default component.exports